import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Cliente, Statistics } from '../model/cliente';
import { ComboGrupo } from '../model/combos';
import { DatosUsuarioCliente } from '../model/datos-usuario-cliente';

interface Clientedato {
  ID_CLIENTE: number;
  NOMBRE_CLIENTE: string;
  isDocout: boolean;
  isSupervisor: boolean;
  IDIOMA: string;
  NameApesUser: string;
  FechaUltimaVisita: Date;
}

@Injectable()
export class ClientesService {

  PATH = environment.API_BASE + '/Clients';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private tranlateService: TranslateService
  ) { }

  getAllClientes(onlyConInventario: boolean = false): Observable<Cliente[]> {
    return this.http.get<Cliente[]>(this.PATH + '?filtrarInventarios=' + onlyConInventario).pipe(map((clientes: Cliente[]) =>
      clientes.map((cliente: Cliente) => Cliente.toModel(JSON.stringify(cliente)))));
  }

  // crea un nuevo cliente
  createClient(direccion: Cliente): Observable<number> {
    return this.http.post(this.PATH, (direccion), { observe: 'response' })
      .pipe(map(success => success.status));
  }
  //  Update cliente
  updateClient(direccion: Cliente): Observable<number> {
    return this.http.put(this.PATH, direccion, { observe: 'response' })
      .pipe(map(success => success.status));
  }

  // get groups
  // CLIENTES	GetClientsName	GET	Clients/GetGroups/{IdClient}


  // get my client name
  // CLIENTES	GetMyClientsName	GET	Clients/GetMyClientName
  public getMyClient(): Observable<DatosUsuarioCliente> {
    return this.http.get<DatosUsuarioCliente>(this.PATH + '/GetMyClientName')
      .pipe(map((datos: DatosUsuarioCliente) => DatosUsuarioCliente.toModel(JSON.stringify(datos))));
  }
  // get clients name
  // CLIENTES	GetGroups	GET	Clients/GetClientsName

  //  Delete cliente
  deleteClienteById(directionId: string): Observable<number> {
    return this.http.delete(this.PATH + '/' + directionId, { headers: this.headers, observe: 'response' })
      .pipe(map(success => success.status));
  }

  getClientById(clientId: number): Observable<Cliente> {
    return this.http.get<any>(this.PATH + '/' + clientId)
      .pipe(map(client => Cliente.toModel(JSON.stringify(client))));
  }

  getGruposCliente(idcliente: number): Observable<ComboGrupo[]> {
    return this.http.get<ComboGrupo[]>(this.PATH + '/GetClientGroups/ ' + idcliente);
  }

  getStatisticDocout(): Observable<Statistics> {
    return this.http.get<Statistics>(this.PATH + '/StatisticsDocout')
      .pipe(map(statistic => Statistics.toModel(JSON.stringify(statistic), this.tranlateService)));
  }

  getStatisticClient(): Observable<Statistics> {
    return this.http.get<Statistics>(this.PATH + '/Statistics')
      .pipe(map(statistic => Statistics.toModel(JSON.stringify(statistic), this.tranlateService)));
  }

  getAreFilesShareable(idClient: number): Observable<boolean> {
    return this.http.get<boolean>(this.PATH + '/GetFilesShareable/' + idClient);
  }


}
